const CACHE_TTL = {
  DEFAULT: 5 * 60 * 1000,
  REALTIME: 60 * 1000,
  LONG_TERM: 30 * 60 * 1000,
  COMPREHENSIVE: 30 * 1000,
};

const dashboardCache = new Map<string, { data: unknown; timestamp: number; ttl: number }>();

const getCacheKey = (endpoint: string, params?: Record<string, unknown>, portfolioId?: string): string => {
  const paramStr = params ? JSON.stringify(params) : '';
  const portfolioPrefix = portfolioId ? `portfolio_${portfolioId}_` : '';
  return `${portfolioPrefix}${endpoint}${paramStr}`;
};

const isCacheValid = (cacheEntry: { timestamp: number; ttl: number }): boolean => {
  return Date.now() - cacheEntry.timestamp < cacheEntry.ttl;
};

const getCachedData = (key: string) => {
  const cached = dashboardCache.get(key);
  if (cached && isCacheValid(cached)) {
    return cached.data;
  }
  return null;
};

const setCachedData = (key: string, data: unknown, ttl: number = CACHE_TTL.DEFAULT) => {
  dashboardCache.set(key, {
    data,
    timestamp: Date.now(),
    ttl,
  });
};

const clearDashboardCache = (endpoint?: string, portfolioId?: string) => {
  if (endpoint && portfolioId) {
    const cacheKey = getCacheKey(endpoint, undefined, portfolioId);
    dashboardCache.delete(cacheKey);
  } else if (endpoint) {
    const keysToDelete: string[] = [];
    dashboardCache.forEach((_, key) => {
      if (key.includes(endpoint)) {
        keysToDelete.push(key);
      }
    });
    keysToDelete.forEach(key => dashboardCache.delete(key));
  } else {
    dashboardCache.clear();
  }
};

const clearCache = (endpoint?: string, portfolioId?: string) => {
  clearDashboardCache(endpoint, portfolioId);
};

export { CACHE_TTL, dashboardCache, getCacheKey, isCacheValid, getCachedData, setCachedData, clearDashboardCache, clearCache };
